module.exports = __webpack_public_path__ + "static/guardian_naga-dc17fa14d1373735d0c725543d647e81.jpg";